import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormService } from '../../../core/services/form.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ExerciseService } from '../exercise.service';
import { StudentRequest } from '@generativ/much-smarter-models';
import { EntryDictionary, CompleteType } from '@generativ/ms-student-types';
import { ContentfulService } from '../../../shared/contentful.service';
import { ParamsService } from '../../../shared/params.service';
import { Subscription } from 'rxjs';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-exercise-complete',
    templateUrl: './exercise-complete.component.html',
    styleUrls: ['./exercise-complete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, MarkdownModule, RouterLink]
})
export class ExerciseCompleteComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  openAnswerForm: UntypedFormGroup;
  isSubmitting = false;
  errorMessage: string;
  content: CompleteType;
  isStrategy = false;
  isPersistence = false;
  accuracyPercentage = 0;

  constructor(public formService: FormService,
              private route: ActivatedRoute,
              private router: Router,
              public exerciseService: ExerciseService,
              private contentfulService: ContentfulService,
              private paramsService: ParamsService) {
    this.openAnswerForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    const problemCase = this.paramsService.getRouteDataById('problemCase', this.route.snapshot).toString();
    this.isStrategy = problemCase === 'strategyProblem';
    this.isPersistence = problemCase === 'persistenceProblem';
    this.contentfulService.getStudentEntry(EntryDictionary.Complete.exerciseComplete).then(
      (entry) => {
        this.content = new CompleteType(entry);
      },
    );
    this.accuracyPercentage = this.exerciseService.getPercentageOfProblemCorrect(this.isPersistence ? 1 : 0);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onPersistedRound() {
    const currentExerciseId = localStorage.getItem('currentExerciseId');
    this.subscriptions.add(this.exerciseService.startExercise(+currentExerciseId, true).subscribe(
      () => {
        this.router.navigate([`../persistence`], {relativeTo: this.route});
      }
    ));
  }

  submitForm() {
    if (this.formService.validateFormAndUpdateErrors(this.openAnswerForm)) {
      this.errorMessage = null;

      if (this.isSubmitting) {
        return;
      }

      if (!this.openAnswerForm.valid) {
        this.errorMessage = 'Errors on form. See fields below.';
        return;
      }

      const body = new StudentRequest.ExerciseCompleteOpenAnswer();
      body.exerciseProgressId = this.exerciseService.getExerciseProgressId();
      body.openAnswer = this.openAnswerForm.get('openAnswer').value;


      this.subscriptions.add(this.exerciseService.postOpenAnswer(body).subscribe(
        () => {
        }
      ));
    }
  }

  private  get formOptions(): Record<string, unknown> {
    return {
      openAnswer: [
        null,
        Validators.compose([
          Validators.required
        ])
      ]
    };
  }

}
